// extracted by mini-css-extract-plugin
export default {"base":"vp_Gi2em","append":"vp_LKdzy","lang":"vp_c0yLY"};